import React from 'react';
import PropTypes from 'prop-types';
import { Button, XClose } from '@opendate-app/setlist';
import { conductorTheme } from '../themeTokens';

// Browsable catalog of example prompts. Selecting one inserts it into the
// composer (it never auto-sends) so the user can tweak names/dates first.
const PromptsToTryPanel = ({ catalog, onSelect, onClose, isMobileLayout = false }) => (
  <div
    role="dialog"
    aria-label="Prompts to try"
    style={{
      position: 'absolute',
      inset: 0,
      zIndex: 30,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(15, 23, 42, 0.45)'
    }}
    onClick={onClose}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: isMobileLayout ? '94%' : '640px',
        maxWidth: '94%',
        maxHeight: '80%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px',
        border: `1px solid ${conductorTheme.borderMuted}`,
        backgroundColor: conductorTheme.surface,
        boxShadow: '0 18px 50px rgba(15, 23, 42, 0.35)'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '14px 18px',
          borderBottom: `1px solid ${conductorTheme.borderMuted}`
        }}
      >
        <div>
          <div style={{ fontSize: '15px', fontWeight: 600, color: conductorTheme.textStrong }}>
            Prompts to try
          </div>
          <div style={{ fontSize: '12px', color: conductorTheme.textFaint }}>
            Pick one to load it into the composer — edit anything in [brackets] before sending.
          </div>
        </div>
        <Button
          variant="tertiary"
          size="sm"
          icon={XClose}
          onClick={onClose}
          aria-label="Close prompts"
          style={{ color: conductorTheme.textSlate, background: 'transparent', border: 'none' }}
        />
      </div>

      <div style={{ overflowY: 'auto', padding: '8px 18px 16px' }}>
        {catalog.map((category) => (
          <div key={category.id} style={{ marginTop: '12px' }}>
            <div
              style={{
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: conductorTheme.textFaint,
                marginBottom: '6px'
              }}
            >
              {category.label}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {category.prompts.map((prompt) => (
                <Button
                  key={prompt}
                  variant="secondary"
                  size="sm"
                  onClick={() => onSelect(prompt)}
                  style={{
                    textAlign: 'left',
                    fontSize: '13px',
                    lineHeight: 1.35,
                    padding: '7px 10px',
                    borderRadius: '8px',
                    border: `1px solid ${conductorTheme.borderMuted}`,
                    backgroundColor: conductorTheme.surfaceMuted,
                    color: conductorTheme.textSlate,
                    whiteSpace: 'normal'
                  }}
                >
                  {prompt}
                </Button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

PromptsToTryPanel.propTypes = {
  catalog: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      prompts: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isMobileLayout: PropTypes.bool
};

export default PromptsToTryPanel;
